import { jsx, jsxs } from "react/jsx-runtime";
const SvgG = (props) => /* @__PURE__ */ jsxs("svg", { "data-name": "Group 16", xmlns: "http://www.w3.org/2000/svg", width: "5.25rem", height: "5.25rem", viewBox: "0 0 199.72 187.676", ...props, children: [
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "ms1lpx30ia", children: /* @__PURE__ */ jsx("path", { "data-name": "Rectangle 22", d: "M0 0h199.72v187.676H0z" }) }) }),
  /* @__PURE__ */ jsx("g", { "data-name": "Group 15", style: {
    clipPath: "url(#ms1lpx30ia)"
  }, children: /* @__PURE__ */ jsx("path", { "data-name": "Path 8", d: "M90.859 5.388 1.225 172.64a10.212 10.212 0 0 0 9 15.036h179.269a10.213 10.213 0 0 0 9-15.036L108.861 5.388a10.212 10.212 0 0 0-18 0" }) })
] });
export default SvgG;
